import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from 'primereact/button'

import { Header } from '../../../../components/Header'
import { useDeliveryForecastById } from '../../data'
import { AcceptDeliveryForecastData } from './dialog'

type Props = {
  deliveryForecastId: string
  isConfirmationActive: boolean
}

export const Title: React.FC<Props> = ({
  deliveryForecastId,
  isConfirmationActive,
}) => {
  const navigate = useNavigate()
  const { data, isLoading } = useDeliveryForecastById(deliveryForecastId)

  const { t } = useTranslation()

  // const messagesRef = useRef<Messages>(null)
  // useEffect(() => {
  //   if (!messagesRef) return

  //   const messages = getVisibleNotes(data?.Payload, 'DELPLA')

  //   if (!messages) return

  //   messages.forEach(message => {
  //     messagesRef.current?.replace({
  //       id: message.HintId,
  //       sticky: true,
  //       severity: 'warn',
  //       closable: false,
  //       icon: PrimeIcons.EXCLAMATION_CIRCLE,
  //       summary: t(`common.visibleNotes.${message.HintId}.summary`),
  //       detail: t(`common.visibleNotes.${message.HintId}.detail`),
  //     })
  //   })
  // }, [t, messagesRef, data?.Payload])

  const actions = (
    <>
      <Button
        label={t('deliveryForecast.title.history.label')}
        className="p-button-text"
        onClick={() =>
          navigate(
            `/delivery-forecasts/history?search=${data?.Payload.ScheduleAgreementNumber} - ${data?.Payload.Items?.[0].Position} - ${data?.Payload.CurrentReleaseNumber}`,
          )
        }
      />

      <AcceptDeliveryForecastData
        deliveryForecastId={deliveryForecastId}
        isConfirmationActive={isConfirmationActive}
      />
    </>
  )

  return (
    <>
      <Header
        title={t(`deliveryForecast.title.title`, {
          scheduleAgreementNumber: data?.Payload.ScheduleAgreementNumber,
        })}
        showBackButton={true}
        showPrintButton={true}
        actions={actions}
        isLoading={isLoading}
      />

      {/* <Messages ref={messagesRef} /> */}
    </>
  )
}
